import React from 'react';
import { BarChart3, Map, TrendingUp } from 'lucide-react';

const QuickIntelligence = ({ loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Intelligence</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-48 bg-gray-200 rounded animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Intelligence</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-3">
            <BarChart3 className="w-5 h-5 text-blue-600" />
            <h3 className="font-semibold text-gray-900">Market Forecast Coverage</h3>
          </div>
          <div className="rounded-lg bg-blue-50 p-4 text-sm text-blue-900">
            <p className="font-medium">Review programs without an IHS/S&P forecast basis.</p>
            <p className="mt-1 text-blue-700">Forecast coverage is required before S&OP volume can be trusted.</p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-3">
            <Map className="w-5 h-5 text-green-600" />
            <h3 className="font-semibold text-gray-900">Program Launch Exposure</h3>
          </div>
          <div className="rounded-lg bg-green-50 p-4 text-sm text-green-900">
            <p className="font-medium">Check SOP/EOP timing across active programs.</p>
            <p className="mt-1 text-green-700">Use Program 360 to confirm owner, linked parts, and planning basis.</p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-3">
            <TrendingUp className="w-5 h-5 text-purple-600" />
            <h3 className="font-semibold text-gray-900">Commercial Actions</h3>
          </div>
          <div className="rounded-lg bg-purple-50 p-4 text-sm text-purple-900">
            <p className="font-medium">Prioritize price gaps, claims, and forecast changes.</p>
            <p className="mt-1 text-purple-700">Activity history should show who changed what and why.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickIntelligence;
